import { PayloadCore } from '../interfaces';
import { Psm } from './Psm';

export interface NavigationTrackerOptions {
  psm: Psm;
  core: PayloadCore;
  env: string;
}

export class NavigationTracker {
  private psm: Psm;
  private core: PayloadCore;
  private env: string;
  private currentUrl: string;
  private isTracking = false;

  constructor(options: NavigationTrackerOptions) {
    this.psm = options.psm;
    this.core = options.core;
    this.env = options.env;
    this.currentUrl = window.location.href;
  }

  public startTracking(): void {
    if (this.isTracking) return;
    this.isTracking = true;

    // Override history methods to create new event 'psmlocationchange'
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPushState.apply(window.history, args);
      window.dispatchEvent(new Event('psmlocationchange'));
    };

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(window.history, args);
      window.dispatchEvent(new Event('psmlocationchange'));
    };

    // Add event listeners for navigation changes
    window.addEventListener('popstate', this.handleNavigation.bind(this));
    window.addEventListener('hashchange', this.handleNavigation.bind(this));
    window.addEventListener('psmlocationchange', this.handleNavigation.bind(this));
  }

  private handleNavigation(): void {
    const newUrl = window.location.href;
    if (this.currentUrl === newUrl) return;

    this.currentUrl = newUrl;

    // Update session and send events
    this.psm.setSessionProperties(false, this.env);
    this.sendEvents();
  }

  private sendEvents(): void {
    // Send identity events
    require('../utils/hydratePayload').hydratePayload(this.psm, this.core);

    this.core.trackIdentityRegistration('identity on page start', new Date().toISOString(), (data) => {
      if (this.psm.queryFlag('doppler-identity-onstart')) {
        this.psm.requestQueue.addItem(data);
        this.psm.resetNewSessionFields();
      }
    });

    this.core.trackIdentityRegistration('identity on page complete', new Date().toISOString(), (data) => {
      if (this.psm.queryFlag('doppler-identity-oncomplete')) {
        this.psm.requestQueue.addItem(data);
        this.psm.resetNewSessionFields();
      }
    });
  }
}

export default NavigationTracker;
